// Source Taken From: https://www.pluralsight.com/guides/re-render-react-component-on-window-resize
import { useState, useEffect } from "react";

function OnResize(props = {}) {
  
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  useEffect(() => {
    if (!!props.listener) {
      props.listener(dimensions);
    }

    const delay = props.delay || 1000;
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }, delay);

    window.addEventListener("resize", debouncedHandleResize);

    return _ => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  });

  return dimensions;
}

function debounce(fn, ms) {
  let timer;
  return _ => {
    clearTimeout(timer);
    timer = setTimeout(_ => {
      timer = null;
      fn.apply(this, arguments);
    }, ms);
  };
};

export default OnResize;